import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import Header from 'components/Header';
import Carousel from 'components/Carousel';
import Loading from 'components/Loading';
import Footer from 'components/Footer';
import styles from './index.less';

import { getValue } from '../../../utils/getValue';

import 'react-photo-view/dist/index.css';

// 移动专用特殊休息室页面 移动项目未下之前 不要删！！！ 20230223

const languageMap = {
  'zh-cn': {
    OfferInfo: '优惠信息',
    ViewDetails: '查看详情',
    Reminder: '温馨提示',
    HotFood: '热食',
    Servicelnfo: '服务介绍',
    LocationInfo: '位置说明',
    Rule: '服务须知',
    Amenities: '设施',
    BoardingGate: '登机口',
    SetMealOption: '套餐内容',
    ServingTime: '供应时间',
    ViewFullMenu: '查看完整菜单',
    Usebtn: '生成使用凭证',
  },
  en: {
    OfferInfo: 'Offer Info',
    ViewDetails: 'View Details',
    Reminder: 'Reminder',
    HotFood: 'Hot Food',
    Servicelnfo: 'Service Info',
    LocationInfo: 'Locational Instructions',
    Rule: 'T&Cs',
    Amenities: 'Amenities',
    BoardingGate: 'BoardingGate',
    SetMealOption: 'Set Meal Option',
    ServingTime: 'Serving Time',
    ViewFullMenu: 'View Full Menu',
    Usebtn: 'CONFIRM TO ACCESS LOUNGE',
  },
};

@connect(({ lounge, cip, loading }) => ({
  loungeMsg: lounge.loungeMsg,
  cipList: cip.cipList,
  loading: loading.effects['lounge/queryLoungeDetail'],
}))
class Lounge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      num: 1,
      showLayer: false,
      selectItem: {},
      cipDetail: {},
    };
  }

  componentDidMount() {
    const { code, language, listType } = this.props.location.query;
    const { cipList } = this.props;
    window.parent && window.parent.postMessage({ iframeType: 'detail' }, '*');
    if (listType) {
      this.setState({
        cipDetail: cipList.find((item) => item.code === code) || {},
      });
      return;
    }
    this.props.dispatch({
      type: 'lounge/queryLoungeDetail',
      payload: {
        code,
        language,
      },
    });
  }

  linkTo(url) {
    window.location.href = url;
  }

  onShowLayer(item) {
    document.body.style.overflowY = 'hidden';
    this.setState({ showLayer: true, selectItem: item });
  }

  onHideLayer() {
    document.body.style.overflowY = 'scroll';
    this.setState({ showLayer: false, selectItem: {} });
  }

  toUse() {
    const dragoncode = localStorage.getItem('dragoncode');
    const { language } = this.props.location.query;
    router.push({
      pathname: '/use',
      query: {
        dragoncode,
        language,
      },
    });
  }

  render() {
    const { loungeMsg, loading } = this.props;
    const { showLayer, selectItem } = this.state;
    let { productsImageList, productItemList, lounge = {}, combosets } = loungeMsg;
    let {
      locationGuideImg,
      locationGuideTips,
      terminal,
      inspection,
      businessHours,
      airportName,
      locationGuide,
      bannerList = [],
    } = lounge;
    const { listType, returnUrl } = this.props.location.query;
    const gq = localStorage.getItem('gq');
    const lg = getValue('language') || 'zh-cn';
    const channel = getValue('channel');
    const dragoncode = getValue('dragoncode');
    const cipDetail = this.state.cipDetail;
    const isCip = listType === 'cip';
    if (isCip) {
      terminal = cipDetail.terminal;
      businessHours = cipDetail.businesshours;
      locationGuide = cipDetail.location;
      inspection = '';
      lounge.ad = cipDetail.serivce;
      lounge.name = cipDetail.name;
      const img = require('images/cipDetail.png');
      productsImageList = [img];
    }
    const img = require('images/cipDetail.png');
    return (
      <Fragment>
        <div className={styles.myHead}>
          <Header
            className={styles.myHead}
            title={'详情'}
            showHome={false}
            showCallBox={false}
            backUrl={() => {
              window.location.href = decodeURIComponent(returnUrl);
              // router.go(-1);
            }}
          />
        </div>
        <Loading loading={loading}>
          <div className={styles.mainContent}>
            {isCip ? (
              <img src={img} style={{ width: '100%' }} />
            ) : (
              <Carousel
                styleClass={{ height: '4.3rem', overflow: 'hidden' }}
                bannerItem={productsImageList}
                autoplay={false}
              />
            )}

            <div className={`${styles.message} ${dragoncode ? styles.hasFooter : ''}`}>
              <div className={styles.messageInner}>
                {/* <div className={styles.terminal}>
                  {terminal}, {inspection}
                </div> */}
                <div className={styles.messageBox}>
                  <div className={styles.lounge}>{lounge.name}</div>
                  <div className={styles.businessHours}>时间：{businessHours}</div>
                </div>
                <div className={styles.line} />

                <div className={styles.messageBox}>
                  <div className={styles.serviceIntro}>
                    <div className={styles.title}>{languageMap[lg].LocationInfo}</div>
                    <div className={styles.locationText}>航站楼：{terminal}</div>
                    {inspection && (
                      <div className={styles.locationText}>安检前/后：{inspection}</div>
                    )}
                    {locationGuide && (
                      <div className={styles.locationText} style={{ lineHeight: '0.4rem' }}>
                        位置：{locationGuide}
                      </div>
                    )}
                  </div>
                </div>

                <div className={styles.line} />

                {lounge && lounge.serviceInstructions && lounge.serviceInstructions.length > 0 ? (
                  <>
                    <div className={styles.messageBox}>
                      <div className={styles.serviceIntro}>
                        <div className={styles.title}>{languageMap[lg].Rule}</div>
                        <div
                          className={styles.serviceIntroInner}
                          dangerouslySetInnerHTML={{ __html: lounge.serviceInstructions }}
                        ></div>
                      </div>
                    </div>
                    <div className={styles.line} />
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </Loading>

        {showLayer && (
          <div className={styles.layerWrap}>
            <div className={styles.layerInner}>
              {selectItem.imgurl && (
                <div>
                  <img className={styles.layerImg} src={`${selectItem.imgurl}`} alt="" />
                </div>
              )}

              <div className={styles.name}>{selectItem.name}</div>
              {selectItem.comboDetailList && (
                <div className={styles.comlistWrapper}>
                  {selectItem.comboDetailList.map((el1, idx1) => {
                    return (
                      <Fragment key={idx1}>
                        <div className={styles.title}>{el1.name}</div>
                        <div>
                          {el1.details &&
                            el1.details.map((el2, idx2) => {
                              return (
                                <div className={styles.content} key={el2.id}>
                                  · {el2.name}
                                </div>
                              );
                            })}
                        </div>
                      </Fragment>
                    );
                  })}
                </div>
              )}
              <img
                className={styles.close}
                src={require('images/close.png')}
                alt=""
                onClick={() => this.onHideLayer()}
              />
              <span className={styles.payerTip}>
                图片仅供参考，实际菜品可能因原材料缺货临时替换成其它菜品
              </span>
            </div>
          </div>
        )}
        <Footer />
      </Fragment>
    );
  }
}

export default Lounge;
